export default __webpack_public_path__ + "static/arcadia-logo-c8654f5c08974545ecfa0642cb9b8dad.png";